import { getUrlParam } from "../../lib/helper";
import { Paper, Stack, Typography } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { blue_chart_color, grey_chart_color } from "../../lib/theme";
import Box from "@mui/material/Box";
import { useConfig } from "../../containers/ConfigContext";

export interface CommonDoughnutDataProps {
  title?: string;
  description?: string;
  yes: number;
  no: number;
  labels: string[];
}

export default function DetailsReportDoughnut(props: CommonDoughnutDataProps) {
  const mobile = getUrlParam("mobile");
  const { title, description, yes, no, labels } = props;
  const { localized } = useConfig();

  return (
    <Stack spacing={2} height={"100%"}>
      {title && (
        <Paper elevation={mobile ? 0 : 2} className="padding-small">
          <Typography variant={"h6"} textAlign={"center"}>
            {localized(title)}
          </Typography>
        </Paper>
      )}
      <Paper elevation={mobile ? 0 : 2} className="padding-normal flex-1">
        <Stack height={"100%"}>
          {description && (
            <Typography variant={"h6"} style={{ paddingBottom: 10 }}>
              <b>{description}</b>
            </Typography>
          )}
          <Box
            className={"all-center-wrapper relative"}
            style={{ width: "70%", margin: "auto" }}
          >
            <Doughnut
              options={{
                plugins: {
                  legend: {
                    display: false,
                  },
                },
                cutout: "70%",
              }}
              data={{
                labels: labels,
                datasets: [
                  {
                    data: [yes, no],
                    backgroundColor: [blue_chart_color, grey_chart_color],
                  },
                ],
              }}
            />
            <div
              className="all-center-wrapper column-wrapper"
              style={{ position: "absolute" }}
            >
              <Typography variant="h4">
                {(+(yes / (yes + no)) * 100).toFixed(0)}%
              </Typography>
            </div>
          </Box>
        </Stack>
      </Paper>
    </Stack>
  );
}
